import { Subscription } from 'rxjs';
import { PlatosService } from './../platos.service';
import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment.prod';
import {
  NgbCalendar,
  NgbDate,
  NgbDateParserFormatter,
  NgbModal,
} from '@ng-bootstrap/ng-bootstrap';
import * as unorm from 'unorm';

@Component({
  selector: 'app-list-platos',
  templateUrl: './list-platos.component.html',
  styleUrls: ['./list-platos.component.scss'],
})
export class ListPlatosComponent implements OnInit, OnDestroy {
  window: any;
  @ViewChild('textarea') textarea!: ElementRef<HTMLTextAreaElement>;

  public subscriptions: Subscription[] = [];
  public platos: any;
  public statusMessage = '';
  public imageBaseURL = '';
  public isLoading = true;
  public currentPage = 1;
  public pageSize = 10;
  public platosLength = 0;
  public keyword = '';
  public selectedPlato: any = null;
  public selectedPlatoInstagramText: any = null;
  public selectedPlatoPlainText: any = null;
  public platoImages: any[] = [];
  public showToast = false;

  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;

  constructor(
    private platosService: PlatosService,
    private router: Router,
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private el: ElementRef,
    private modalService: NgbModal
  ) {
    this.fromDate = null;
    this.toDate = null;
    this.resetFilters();

    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      const state = navigation?.extras.state as { data: string };
      this.statusMessage = state.data;
    }
    console.log('this.statusMessage: ', this.statusMessage);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  ngOnInit(): void {
    this.subscriptions = [];
    window.scroll(0, 0);
    this.imageBaseURL = environment.imageBaseURL;
  }

  public resetFilters(): void {
    this.fromDate = new NgbDate(2015, 1, 1);
    this.toDate = this.calendar.getToday();
    this.currentPage = 1;
    this.keyword = '';
    console.log('this.fromDate: ', this.fromDate);
    console.log('this.toDate: ', this.toDate);
    this.getPlatosLength();
  }

  public onPageChange(page: number): void {
    console.log('Changing page to: ', page);
    this.getPlatos(
      page,
      this.pageSize,
      this.fromDate,
      this.toDate,
      this.keyword
    );
  }

  public onKeywordSearch(): void {
    console.log('This.keyword: ', this.keyword);

    this.fromDate = new NgbDate(2015, 1, 1);
    this.toDate = this.calendar.getToday();
    this.currentPage = 1;
    this.keyword = this.keyword.trim();
    this.getPlatosLength();
  }

  public onDateSelection(date: NgbDate, isInterval: boolean): void {
    console.log('date: ', date);
    this.currentPage = 1;
    if (isInterval) {
      if (!this.fromDate && !this.toDate) {
        this.fromDate = date;
      } else if (
        this.fromDate &&
        !this.toDate &&
        date &&
        date.after(this.fromDate)
      ) {
        this.toDate = date;
      } else {
        this.toDate = null;
        this.fromDate = date;
      }
    } else {
      this.fromDate = date;
      this.toDate = date;
    }
    this.getPlatosLength();
  }

  public isHovered(date: NgbDate): boolean | null {
    return (
      this.fromDate &&
      !this.toDate &&
      this.hoveredDate &&
      date.after(this.fromDate) &&
      date.before(this.hoveredDate)
    );
  }

  public isInside(date: NgbDate): boolean | null {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate): boolean | null {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }
  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed))
      ? NgbDate.from(parsed)
      : currentValue;
  }

  private getPlatosLength(): void {
    this.subscriptions.push(
      this.platosService
        .getPlatosLength(
          this.fromDate ? this.formatter.format(this.fromDate) : '2000-01-01',
          this.toDate ? this.formatter.format(this.toDate) : '2099-12-31',
          this.keyword
        )
        .subscribe(
          (response) => {
            this.platosLength = response[0].length;
            console.log('platosLength: ', this.platosLength);
            this.getPlatos(
              this.currentPage,
              this.pageSize,
              this.fromDate,
              this.toDate,
              this.keyword
            );
            console.log(this.platos);
            if (this.keyword && this.platos && this.platos.length > 0) {
              setTimeout(() => {
                this.getHighlight();
                console.log('Finding in window method 2...');
              }, 600);
            }
            /*
            // @ts-ignore
            if (this.keyword && window.find && window.getSelection) {
              setTimeout(() => {
                // @ts-ignore
                window.find(this.keyword);
                console.log('Finding in window...');
              }, 600);
            }*/
          },
          (err) => {
            console.log(err);
            this.isLoading = false;
          }
        )
    );
  }

  private getHighlight() {
    const textToSearch = unorm
      .nfd(this.keyword)
      .replace(/[\u0300-\u036f]/g, '');
    if (textToSearch) {
      // Obtener todos los elementos con la clase 'plato-description'
      const platoDescriptionElements =
        this.el.nativeElement.querySelectorAll('.plato-description');

      // Recorrer cada elemento y buscar/resaltar dentro de él
      platoDescriptionElements.forEach((element: any) => {
        const content = unorm
          .nfd(element.innerHTML)
          .replace(/[\u0300-\u036f]/g, '');
        const highlightedContent = content.replace(
          new RegExp(textToSearch, 'gi'),
          (match: any) => {
            return `<span class="highlighted">${match}</span>`;
          }
        );
        element.innerHTML = highlightedContent;
      });
    } else {
      // Limpiar resaltados previos si la búsqueda está vacía
      this.removeHighlight();
    }
  }

  private removeHighlight() {
    const highlightedElements =
      this.el.nativeElement.querySelectorAll('.highlighted');
    highlightedElements.forEach((element: any) => {
      const parent = element.parentNode;
      parent.replaceChild(element.firstChild, element);
      parent.normalize();
    });
  }

  private getPlatos(
    currentPage: number,
    pageSize: number,
    fromDate: NgbDate | null,
    toDate: NgbDate | null,
    keyword: string
  ): void {
    this.subscriptions.push(
      this.platosService
        .getPlatos(
          currentPage,
          pageSize,
          fromDate ? this.formatter.format(fromDate) : '2000-01-01',
          toDate ? this.formatter.format(toDate) : '2099-12-31',
          keyword ? keyword : this.keyword
        )
        .subscribe(
          (response) => {
            this.platos = response;
            this.isLoading = false;
            console.log(this.platos);
            console.log(this.platos);
            if (this.keyword && this.platos && this.platos.length > 0) {
              setTimeout(() => {
                this.getHighlight();
                console.log('Finding in window method 2...');
              }, 600);
            }
          },
          (err) => {
            console.log(err);
            this.isLoading = false;
          }
        )
    );
  }

  public onOpenModal(content: any, plato: any): void {
    this.selectedPlato = plato;
    this.selectedPlatoInstagramText = '';
    this.selectedPlatoPlainText = '';
    this.platoImages = [];

    // Lista de emojis para iniciar el post
    const postStartEmojis = [
      '✅',
      '🔥',
      '🏆',
      '🌟',
      '🏅',
      '👇',
      '💬',
      '✨',
      '🔄',
    ];

    const linkText = [
      'Más info',
      'Más información',
      'Información completa',
      'Descubre la no-receta',
      'Descúbrelo en',
      'Saber más',
      'Disponible en',
      'Consulta más en',
      'Accede a',
    ];

    const linkEmojis = ['🌍', '🔗', '📎', '📌', '🖇️', '🔍', '👉'];

    // Lista de emojis de comida
    const foodEmojis = [
      '🥙',
      '🍚',
      '🍛',
      '🥗',
      '🍜',
      '🍏',
      '🍎',
      '🍌',
      '🍉',
      '🍇',
      '🍓',
      '🍍',
      '🥭',
      '🥑',
      '🥕',
      '🥒',
      '🌽',
      '🍆',
      '🍋',
      '🍊',
      '🧂',
      '🌿',
      '🥜',
      '🌰',
      '🫒',
      '🍵',
      '🍯',
      '🥧',
      '🍳',
      '🥘',
      '🍽️',
      '🥄',
      '🍴',
      '🔪',
      '🥣',
      '🌡️',
    ];

    // Función para obtener un emoji aleatorio
    const getRandomPostEmoji = () =>
      postStartEmojis[Math.floor(Math.random() * postStartEmojis.length)];
    const getRandomLinkEmoji = () =>
      linkEmojis[Math.floor(Math.random() * linkEmojis.length)];
    const getRandomLinkText = () =>
      linkText[Math.floor(Math.random() * linkText.length)];
    const getRandomFoodEmoji = () =>
      foodEmojis[Math.floor(Math.random() * foodEmojis.length)];

    // Añadir descripción del horario con emoji aleatorio
    if (plato.horario_description) {
      this.selectedPlatoInstagramText += `${getRandomPostEmoji()} ${
        plato.horario_description
      }`;
      this.selectedPlatoPlainText +=
        'CookAdHoc: Cocina sin recetas. ' + plato.horario_description;
    }

    // Formatear la fecha si existe
    if (plato.plato_date) {
      this.selectedPlatoInstagramText += ' del ';
      this.selectedPlatoPlainText += ' del ';
      const fecha = new Date(plato.plato_date);
      const opciones: Intl.DateTimeFormatOptions = {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      };
      const fechaLegible = fecha.toLocaleDateString('es-ES', opciones);
      this.selectedPlatoInstagramText += `${fechaLegible}.\n\n`;
      this.selectedPlatoPlainText += fechaLegible + '.\n\n';
    } else {
      this.selectedPlatoInstagramText += '.\n\n';
      this.selectedPlatoPlainText += '.\n\n';
    }

    if (plato.url_slug) {
      this.selectedPlatoInstagramText += `${getRandomLinkEmoji()} ${getRandomLinkText()}: https://app.cookadhoc.com/tabs/platos/${
        plato.url_slug
      }\n\n`;
    }

    // Añadir la descripción del plato con emoji aleatorio
    if (plato.plato_description) {
      this.selectedPlatoInstagramText += `${plato.plato_description.trim()}`;
    }

    // Obtener los datos adicionales para redes
    this.platosService.getPlatoRedes(plato.plato_id).subscribe(
      (response) => {
        console.log('Información del plato para redes: ', response);

        // Convertir la cadena de imágenes en un array (si existe)
        this.platoImages = response.imagenes
          ? response.imagenes.split(', ').map((img: string) => ({
              imageUrl: img, // Imagen original
              imageDownload: img.replace('/images/', '/download/images/l-'), // URL de descarga
            }))
          : [];

        let hashtags: string[] = [];

        // Añadir valores como hashtags en el orden correcto
        if (response.dieta)
          hashtags.push(`#${this.formatHashtag(response.dieta)}`);
        if (response.estacion)
          hashtags.push(`#${this.formatHashtag(response.estacion)}`);

        if (response.tecnicas) {
          hashtags = hashtags.concat(
            response.tecnicas
              .split(', ')
              .map((t: string) => `#${this.formatHashtag(t)}`)
          );
        }

        if (response.ingredientes) {
          hashtags = hashtags.concat(
            response.ingredientes
              .split(', ')
              .map((i: string) => `#${this.formatHashtag(i)}`)
          );
        }

        if (response.condimentos) {
          hashtags = hashtags.concat(
            response.condimentos
              .split(', ')
              .map((c: string) => `#${this.formatHashtag(c)}`)
          );
        }

        this.selectedPlatoInstagramText +=
          '\n\n¿Cocinas sin recetas? Déjanos un comentario 👇💬';

        if (response.ciudad)
          hashtags.push(`#${this.formatHashtag(response.ciudad)}`);
        if (response.pais)
          hashtags.push(`#${this.formatHashtag(response.pais)}`);

        // Agregar hashtags al texto final
        this.selectedPlatoInstagramText += '\n\n';
        if (hashtags.length > 0) {
          this.selectedPlatoInstagramText += hashtags.join(' ');
        }

        // Hashtags genéricos al final
        this.selectedPlatoInstagramText +=
          '\n\n#cookadhoc #aliciarios #dietamediterranea #adhoc #adhocismo #adhocista #adhocism #cocinasinrecetas';
        this.selectedPlatoInstagramText +=
          ' #cocinaadhoc #cocinaintuitiva #aprendizajeculinario #cocinasaludable #comidasaludable';
        this.selectedPlatoInstagramText += ' #app #appstore #googleplay';

        this.selectedPlatoInstagramText +=
          '\n\n\n' +
          getRandomFoodEmoji() +
          '  Descubre el diario de comida y cocina de Alicia Ríos, CookAdHoc: Cocina sin recetas\n\n' +
          '🔗  https://apps.apple.com/app/cookadhoc/id6446223541\n' +
          '🔗  https://play.google.com/store/apps/details?id=cookadhoc.cocina.sin.recetas';

        //Comprobar el límite de caracteres de Instagram
        const charLimit = 2200;
        if (this.selectedPlatoInstagramText.length > charLimit) {
          this.selectedPlatoInstagramText = this.selectedPlatoInstagramText
            .replace(
              '🔗  https://apps.apple.com/app/cookadhoc/id6446223541',
              ''
            )
            .replace(
              '🔗  https://play.google.com/store/apps/details?id=cookadhoc.cocina.sin.recetas',
              ''
            )
            .replace(
              'Descubre el diario de comida y cocina de Alicia Ríos con CookAdHoc: cocina sin recetas:',
              'Descubre el diario de comida y cocina de Alicia Ríos con CookAdHoc: cocina sin recetas.'
            );
          this.selectedPlatoInstagramText =
            this.selectedPlatoInstagramText.trim();

          if (this.selectedPlatoInstagramText.length > charLimit) {
            this.selectedPlatoInstagramText =
              this.selectedPlatoInstagramText.substring(0, charLimit - 4) +
              ' ...';
          }
        }
      },
      (err) => {
        console.log(err);
      }
    );

    console.log('Compartiendo en redes plato: ', plato);
    this.modalService.open(content, { size: 'xl' });
  }

  // Función para formatear hashtags eliminando espacios y tildes pero manteniendo la ñ
  // Función para formatear hashtags eliminando tildes pero manteniendo la ñ
  private formatHashtag(text: string): string {
    return text
      .trim()
      .toLowerCase()
      .replace(/[á]/g, 'a')
      .replace(/[é]/g, 'e')
      .replace(/[í]/g, 'i')
      .replace(/[ó]/g, 'o')
      .replace(/[ú]/g, 'u')
      .replace(/\s+/g, '') // Elimina espacios
      .replace(/[^a-zñ]/g, ''); // Mantiene solo letras y la "ñ"
  }

  public autoResize(textarea: HTMLTextAreaElement): void {
    console.log('Reajustando textarea');
    textarea.style.height = 'auto'; // Resetea la altura
    textarea.style.height = textarea.scrollHeight + 'px'; // Ajusta la altura al contenido
  }

  public copyToClipboard(event: Event): void {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    target.select();
    navigator.clipboard
      .writeText(target.value)
      .then(() => {
        this.showToast = true; // Mostrar el Toast
        setTimeout(() => (this.showToast = false), 300000); // Ocultarlo después de 3 segundos
      })
      .catch((err) => console.error('Error al copiar: ', err));
  }

  public downloadImage(imgPath: string): void {
    const imageUrl = this.imageBaseURL + imgPath;

    fetch(imageUrl, { mode: 'no-cors' })
      .then((response) => response.blob())
      .then((blob) => {
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = imgPath.split('/').pop() || 'imagen.jpg';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(blobUrl);
      })
      .catch((error) => console.error('Error al descargar la imagen:', error));
  }

  public encodeUrl(url: string): string {
    return encodeURIComponent(url);
  }
}
